import React from 'react';
import { Modal, View, Image, ActivityIndicator } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Text } from '@shared/components/text';
import Button from '@shared/components/md-design-system/Button/Button';
import { colorPalette } from '@shared/config/colorsConfig';
import { dynamicTranslations } from '@shared/utils/dynamicTranslation';

interface PhotoReviewModalProps {
  photoUri: string | null;
  isUploading: boolean;
  onSend: () => void;
  onRetake: () => void;
  onClose: () => void;
}

export const PhotoReviewModal: React.FC<PhotoReviewModalProps> = ({
  photoUri,
  isUploading,
  onSend,
  onRetake,
  onClose,
}) => {
  const { t } = dynamicTranslations();
  const insets = useSafeAreaInsets();
  const s = 'history.documents.patientSection.photoReview';

  if (!photoUri) return null;

  return (
    <Modal
      visible
      animationType="slide"
      onRequestClose={isUploading ? () => {} : onClose}
      supportedOrientations={['portrait', 'landscape']}
    >
      <View
        className="flex-1 bg-black px-5"
        style={{ paddingTop: insets.top + 16, paddingBottom: insets.bottom + 16 }}
      >
        <Text className="text-white text-xl font-bold">{t(`${s}.title`)}</Text>
        <Text className="text-white text-base mt-1 mb-4">{t(`${s}.notSentYet`)}</Text>

        <View className="flex-1 justify-center">
          <Image source={{ uri: photoUri }} resizeMode="contain" className="w-full h-full" />
          {isUploading && (
            <View className="absolute inset-0 justify-center items-center bg-black/50">
              <ActivityIndicator size="large" color={colorPalette.white} />
            </View>
          )}
        </View>

        <View className="mt-4">
          <Button variant="primary" size="large" icon="check" onPress={onSend} disabled={isUploading}>
            {t(`${s}.send`)}
          </Button>
          <Button variant="outline" size="large" icon="redo" onPress={onRetake} disabled={isUploading}>
            {t(`${s}.retake`)}
          </Button>
        </View>
      </View>
    </Modal>
  );
};
